class LazyScriptLoader {
  constructor() {
    this.scripts = [];
    this.selector = "script[data-loading=\"lazy\"][data-src]";
    this.interactionEvents = ["keydown", "touchstart", "click"];
    this.loadAfterMsIfNoInteraction = 5000;
    this.loadTimer = null;
    this.hasStartedLoading = false;
    this.boundStartLoadingScripts = this.startLoadingScripts.bind(this);
    this.eventOptions = { passive: true };
  }


  init() {
    // find all scripts
    this.scripts = document.querySelectorAll(this.selector);

    // if there are no scripts, return
    if (this.scripts.length === 0) return;

    // load scripts on user interaction
    this.interactionEvents.forEach((event) => {
      document.addEventListener(event, this.boundStartLoadingScripts, this.eventOptions);
    });

    // load scripts after a timeout if no user interaction
    this.loadTimer = setTimeout(this.boundStartLoadingScripts, this.loadAfterMsIfNoInteraction);
  }

  startLoadingScripts() {
    if (this.hasStartedLoading) return;
    this.hasStartedLoading = true;
    clearTimeout(this.loadTimer);

    this.loadScripts();
    this.interactionEvents.forEach((event) => {
      document.removeEventListener(event, this.boundStartLoadingScripts, this.eventOptions);
    });
  }

  loadScripts() {
    this.scripts.forEach((script) => {
      if (script.dataset.loading === "loaded") return;
      this.loadScript(script);
    });
  }

  loadScript(script) {
    script.dataset.loading = "loaded";
    script.src = script.dataset.src;
    script.removeAttribute("data-src");
  }
}

const loader = new LazyScriptLoader();
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", loader.init.bind(loader));
} else {
  loader.init();
}
